// Local translations
export const T = {
  en_GB: {
    edit: "Edit",
    portfolioCosts: "Portfolio Costs",
    description: "Configure advisor/platform costs with tiered brackets based on portfolio value.",
    addPortfolioCost: "Add Portfolio Cost",
    noPortfolioCosts: 'No portfolio costs configured. Click "Add Portfolio Cost" to create one.',
    name: "Name",
    category: "Category",
    type: "Type",
    value: "Value",
    actions: "Actions",
    notSet: "Not set",
    tiered: "Tiered",
    deletePortfolioCost: "Delete Portfolio Cost",
    deleteConfirmation:
      "Are you sure you want to delete this portfolio cost? This action cannot be undone.",
    delete: "Delete",
    cancel: "Cancel",
    portfolioCostDeleted: "Portfolio cost deleted successfully",
    error: "Error",
    failedToDelete: "Failed to delete portfolio cost",
    categoryRecurring: "Recurring",
    categoryDeposit: "Deposit",
    categoryWithdrawal: "Withdrawal (not supported)",
    costTypeAmount: "Amount",
    costTypePercentage: "Percentage",
    more: "more",
  },
  nb_NO: {
    edit: "Rediger",
    portfolioCosts: "Porteføljekostnader",
    description:
      "Konfigurer rådgiver-/plattformkostnader med nivåbaserte intervaller basert på porteføljeverdi.",
    addPortfolioCost: "Legg til porteføljekostnad",
    noPortfolioCosts:
      'Ingen porteføljekostnader konfigurert. Klikk "Legg til porteføljekostnad" for å opprette en.',
    name: "Navn",
    category: "Kategori",
    type: "Type",
    value: "Verdi",
    actions: "Handlinger",
    notSet: "Ikke satt",
    tiered: "Nivåbasert",
    deletePortfolioCost: "Slett porteføljekostnad",
    deleteConfirmation:
      "Er du sikker på at du vil slette denne porteføljekostnaden? Denne handlingen kan ikke angres.",
    delete: "Slett",
    cancel: "Avbryt",
    portfolioCostDeleted: "Porteføljekostnad slettet",
    error: "Feil",
    failedToDelete: "Kunne ikke slette porteføljekostnad",
    categoryRecurring: "Løpende",
    categoryDeposit: "Innskudd",
    categoryWithdrawal: "Uttak (ikke støttet)",
    costTypeAmount: "Beløp",
    costTypePercentage: "Prosent",
    more: "flere",
  },
} as const;
